import { render, staticRenderFns } from "./Song.vue?vue&type=template&id=94ce6d3c"
import script from "./Song.vue?vue&type=script&lang=js"
export * from "./Song.vue?vue&type=script&lang=js"
import style0 from "./Song.vue?vue&type=style&index=0&id=94ce6d3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports